import { Location } from "../../model/location";
import { asSelectOptions, SelectOptionsType } from "../../utils/select-helpers";
import { fetchGetJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = Location;

type fetchResponseType = {
  data?: DtoType[];
  error?: string;
};

export type GuiResponseType = {
  data?: SelectOptionsType[];
  error?: string;
};

export async function getLocationsUnPooled(): Promise<GuiResponseType> {
  try {
    const response: fetchResponseType = await fetchGetJSON(
      apiUrls.getLocationsUnPooled
    );
    if (response.error) {
      return { error: response.error };
    } else if (response.data) {
      const xResponseData = asSelectOptions({
        data: response.data,
        labelColumn: "name",
        valueColumn: "name",
      });
      return { data: xResponseData };
    }
    return { error: "invariant violation" };
  } catch (err) {
    console.error("Error getLocationsUnPooled:", err);
    return { error: (err as Error).message };
  }
}
